"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeUserDirectoryAdapter = void 0;
const sample_data_1 = require("@home-health-notify/sample-data");
const utils_1 = require("../../utils");
class FakeUserDirectoryAdapter {
    getAppDirectory() {
        return Promise.resolve((0, utils_1.CompletedResult)(sample_data_1.appDirectoriesData.data));
    }
    getUserDirectory() {
        return Promise.resolve((0, utils_1.CompletedResult)(sample_data_1.userDirectoriesData.data));
    }
    getUserInfo(userId) {
        throw new Error(`Method not implemented. ${userId}`);
    }
    getUserWorkload(userId) {
        throw new Error(`Method not implemented. ${userId}`);
    }
}
exports.FakeUserDirectoryAdapter = FakeUserDirectoryAdapter;
